import React from 'react'
import {
  makeStyles,
  Grid,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  useClientOptions
} from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses, DialogProps } from '@paintscout/ui'
import type { BulkOperation } from '@paintscout/util/builder'
import { getObjectLabels } from '@paintscout/util/builder'

const useStyles = makeStyles<Theme>((theme) => ({
  root: {},
  changeDiv: {
    marginBottom: theme.spacing(2)
  },
  titleDiv: {
    marginBottom: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  noChangesDiv: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: theme.spacing(10)
  },
  changeItems: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  }
}))

export interface EditBulkReviewDialogProps extends DialogProps {
  classes?: StyleClasses<typeof useStyles>
  executableOperations: BulkOperation[]
  oldTotalMaterials: number
  newTotalMaterials: number
  oldTotalPrice: number
  newTotalPrice: number
  onConfirm: () => void
  onCancel: () => void
}

function EditBulkReviewDialog(props: EditBulkReviewDialogProps) {
  const classes = useStyles(props)
  const {
    onConfirm,
    onCancel,
    executableOperations,
    oldTotalMaterials,
    oldTotalPrice,
    newTotalMaterials,
    newTotalPrice
  } = props

  const { options } = useClientOptions()
  const objectLabels = getObjectLabels({ options })

  const leftButton = (
    <Button onClick={onCancel} variant="textNoPadding">
      Back
    </Button>
  )
  console.log('executableOperations', executableOperations)

  return (
    <Dialog className={classes.root} open fullWidth={true} maxWidth={'md'}>
      <DialogTitle>{`Bulk Edit Review`}</DialogTitle>
      <DialogContent>
        {executableOperations.length > 0 && (
          <>
            <Grid container spacing={1} className={classes.titleDiv}>
              <Grid item xs={5}>
                <Typography variant={'h5'}>{`Update Locations`}</Typography>
              </Grid>
              <Grid className={classes.changeItems} item xs={3}>
                <Typography variant={'h5'}>{'Old Material'}</Typography>
              </Grid>
              <Grid className={classes.changeItems} item xs={1}>
                {/* {'>'} */}
              </Grid>
              <Grid className={classes.changeItems} item xs={3}>
                <Typography variant={'h5'}>{'New Material'}</Typography>
              </Grid>
            </Grid>
            <hr />
          </>
        )}
        {executableOperations.length > 0 ? (
          executableOperations.map((bulkOperation, index) => {
            return (
              <Grid container spacing={2} key={index} className={classes.changeDiv}>
                <Grid item xs={6}>
                  <Typography variant={'h6'}>{`Change # ${index + 1}`}</Typography>
                  {bulkOperation.lineItems?.length > 0 &&
                    bulkOperation.lineItems.map((lineItem, lineItemIndex) => {
                      return (
                        <div key={lineItemIndex}>
                          <Typography variant={'body1'}>{`Line Item: ${lineItem.name}`}</Typography>
                        </div>
                      )
                    })}
                  {bulkOperation.substrates?.length > 0 &&
                    bulkOperation.substrates.map((substrate, substrateIndex) => {
                      return (
                        <div key={substrateIndex}>
                          <Typography
                            variant={'body1'}
                          >{`${objectLabels.substrate.value}: ${substrate.name} - ${substrate.substrate.rate.label}`}</Typography>
                        </div>
                      )
                    })}
                </Grid>
                <Grid className={classes.changeItems} item xs={2}>
                  <Typography variant={'h6'}>{`${
                    bulkOperation?.oldProduct === 'ADD_NEW_PRODUCT' ? 'Add Material' : bulkOperation.oldProduct
                  }`}</Typography>
                </Grid>
                <Grid className={classes.changeItems} item xs={1}>
                  {'>'}
                </Grid>
                <Grid className={classes.changeItems} item xs={3}>
                  <Typography variant={'h6'}>{`${
                    bulkOperation?.newProduct.label === 'REMOVE_PRODUCT'
                      ? 'Remove Material'
                      : bulkOperation?.newProduct.label
                  }`}</Typography>
                  {bulkOperation?.newProduct.label != 'REMOVE_PRODUCT' && bulkOperation?.newProduct?.color && (
                    <Typography variant={'body1'}>{`Color: ${
                      bulkOperation?.newProduct?.color === '' ? 'unchanged' : bulkOperation?.newProduct.color
                    }`}</Typography>
                  )}
                </Grid>
              </Grid>
            )
          })
        ) : (
          <Grid container spacing={2} className={classes.noChangesDiv}>
            <Typography variant={'body1'}>{`No changes to review`}</Typography>
          </Grid>
        )}

        {executableOperations.length > 0 && (
          <>
            <hr />
            <Grid container spacing={3}>
              <Grid item xs={3}>
                <Typography variant={'h5'}>{`Materials Total: `}</Typography>
              </Grid>
              <Grid item xs={2}>
                ${oldTotalMaterials}
              </Grid>
              <Grid item xs={1}>
                {'>'}
              </Grid>
              <Grid item xs={2}>
                ${newTotalMaterials}
              </Grid>
              <Grid item xs={1}>
                {'='}
              </Grid>
              <Grid item xs={1}>
                {(oldTotalMaterials - newTotalMaterials).toFixed(2)}
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={3}>
                <Typography variant={'h5'}>{`Quote Total: `}</Typography>
              </Grid>
              <Grid item xs={2}>
                ${oldTotalPrice}
              </Grid>
              <Grid item xs={1}>
                {'>'}
              </Grid>
              <Grid item xs={2}>
                ${newTotalPrice}
              </Grid>
            </Grid>
          </>
        )}
      </DialogContent>
      <DialogActions showBorder={true} leftButton={leftButton}>
        <Button onClick={onConfirm} variant={'contained'}>
          Done
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default EditBulkReviewDialog
